var r={CLIENT:"ck",SERVER:"sk"},n={DEVELOPMENT:"development",STAGING:"staging",PRODUCTION:"production"},t={CLIENT:"client",SERVER:"server"};export{r as a,n as b,t as c};
